@if (!useSummaryView) {
  @if (!field.hidden) {
    <div animate.enter="fade-in" class="flex flex-col w-full mb-3">
      <div class="mb-2">
        <div class="leading-6 font-medium">{{ field.label | localize }}</div>
        @if (field.hint) {
          <div class="text-md text-secondary">{{ field.hint | localize }}</div>
        }
      </div>
      <!-- Aqui ira el contenedor del fichero -->
      <multifile-uploader-component [acceptedExtensions]="field.extensions" [control]="field.control"
        [filePattern]="null" [embedded]="false" [min]="field.min" [max]="field.max" [isComponentImage]="true">
      </multifile-uploader-component>
      @if (!field.readonly && !field.control.disabled && field.control.touched && field.control.errors) {
        @if (field.control.errors.required) {
          <div class="text-sm text-warn leading-none font-medium mt-2">
            {{ 'errorRequiredField' | transloco }}
          </div>
        }
        @if (field.control.errors.min) {
          <div class="text-sm text-warn leading-none font-medium mt-2">
            {{ 'errorMinValueField' | transloco:{ min: field.control.errors.min.min } }}
          </div>
        }
        @if (field.control.errors.max) {
          <div class="text-sm text-warn leading-none font-medium mt-2">
            {{ 'errorMaxValueField' | transloco:{ max: field.control.errors.max.max } }}
          </div>
        }
      }
    </div>
  }
}